import { observer } from 'mobx-react-lite';
import { DATA } from '../../../../game/data';
import { AirportSlug } from '../../../../game/data/airportData';
import { LoungeUpgradeType, LOUNGE_UPGRADES } from '../../../../game/data/loungeData';
import { formatNumber } from '../../../../game/helpers';
import { Lounge } from '../../../../game/lounge';
import { GreenButton } from '../../Reusable/GreenButton';
import { UpgradeButton } from '../../Reusable/UpgradeButton';

export const LoungeItem: React.FC<{ airportSlug: AirportSlug; highlight?: boolean }> = observer(({ airportSlug, highlight }) => {
  const lounge = DATA.lounges.find((l) => l.airportSlug === airportSlug);
  const airport = DATA.airportBySlug(airportSlug);

  if (!lounge) {
    const buyLounge = () => {
      DATA.addMoney(-airport.loungePrice);
      DATA.addLounge(new Lounge(airport.slug, DATA.lounges.length));
      DATA.save();
    };
    const hasMoney = airport.loungePrice <= DATA.money;

    return (
      <div className={`${highlight ? 'highlight' : ''}`} style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ flex: 1 }}>Open lounge in {airport.name}</div>
        <GreenButton style={{ minWidth: '6rem' }} disabled={!hasMoney} onClick={hasMoney ? buyLounge : undefined}>
          ${formatNumber(airport.loungePrice)}
        </GreenButton>
      </div>
    );
  }

  const buyUpgrade = (type: LoungeUpgradeType) => {
    const buy = () => {
      const upgradeCost = lounge.getUpgradePrice(type);
      DATA.addMoney(-upgradeCost);
      lounge.increaseUpgradeLevel(type);
    };
    if (DATA.buyMode === 'buy-1') {
      buy();
    } else if (DATA.buyMode === 'buy-max') {
      let upgradeCost = lounge.getUpgradePrice(type);
      while (upgradeCost <= DATA.money && lounge.upgrades[type] < LOUNGE_UPGRADES[type].maxValue) {
        buy();
        upgradeCost = lounge.getUpgradePrice(type);
      }
    }
  };

  return (
    <div className={`${highlight ? 'highlight' : ''}`} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <h3 style={{ marginBottom: 4 }}>{airport.name} Lounge</h3>
      <div style={{ display: 'flex', flexDirection: 'row', gap: 4 }}>
        {(Object.keys(LOUNGE_UPGRADES) as LoungeUpgradeType[]).map((upgrade) => {
          const maxLevel = lounge.upgrades[upgrade] >= LOUNGE_UPGRADES[upgrade].maxValue;
          const hasMoney = lounge.getUpgradePrice(upgrade) <= DATA.money;
          return (
            <UpgradeButton
              key={upgrade}
              onClick={() => buyUpgrade(upgrade)}
              icon={LOUNGE_UPGRADES[upgrade].icon}
              price={lounge.getUpgradePrice(upgrade)}
              value={LOUNGE_UPGRADES[upgrade].readableValue(lounge.upgrades[upgrade])}
              maxLevel={maxLevel}
              hasMoney={hasMoney}
            />
          );
        })}
      </div>
    </div>
  );
});
